import { render, staticRenderFns } from "./scrisoareMedicala.vue?vue&type=template&id=16c829c9"
import script from "./scrisoareMedicala.vue?vue&type=script&lang=js"
export * from "./scrisoareMedicala.vue?vue&type=script&lang=js"
import style0 from "./scrisoareMedicala.vue?vue&type=style&index=0&id=16c829c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports